'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _prism = require('react-syntax-highlighter/prism');

var _prism2 = _interopRequireDefault(_prism);

var _prism3 = require('react-syntax-highlighter/styles/prism');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstract stuff


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
var Fragment = _react2.default.Fragment;

/**
  * codeParser
  */

var codeParser = function codeParser(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { indent: -20 };

  var frag = _react2.default.createElement(Fragment, null);
  frag = _react2.default.createElement(
    'div',
    { style: { marginLeft: options.indent, marginRight: options.indent } },
    _react2.default.createElement(
      _prism2.default,
      { language: 'jsx', style: _prism3.github },
      element.value
    )
  );
  return frag;
};

codeParser.propTypes = process.env.NODE_ENV !== "production" ? {} : {};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
exports.default = codeParser;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/markdown-to-react/lib/parsers/codeParser.js
// module id = 436
// module chunks = 168707334958949